var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _rect, _path21, _path22, _path23, _g, _path24;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDeletePages = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 159,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.14449 83.6778C9.93303 55.4888 36.888 33.454 68.4114 19.1673C100.149 4.78348 139.885 -3.95859 175.589 8.24413C209.384 19.7946 221.141 49.0879 232.436 75.2272C242.736 99.0628 255.427 127.12 234.809 145.287C215.388 162.4 177.843 149.638 146.84 150.651C118.15 151.587 89.6045 162.94 64.7281 150.84C33.5559 135.679 8.39601 110.435 9.14449 83.6778Z",
    fill: "#FAF9F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M192.535 75.7173C193.164 73.9371 194.862 72.6616 196.858 72.6616C198.853 72.6616 200.551 73.9371 201.18 75.7173",
    stroke: "#D2294B",
    strokeWidth: 0.932643,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M209.844 78.7729H183.871",
    stroke: "#D2294B",
    strokeWidth: 0.932643,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M207.298 82.5928L206.595 93.1333C206.325 97.1896 206.19 99.2177 204.868 100.454C203.547 101.69 201.514 101.69 197.449 101.69H196.267C192.202 101.69 190.169 101.69 188.848 100.454C187.526 99.2177 187.391 97.1896 187.121 93.1333L186.418 82.5928",
    stroke: "#D2294B",
    strokeWidth: 0.932643,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M193.039 86.4121L193.802 94.0512",
    stroke: "#D2294B",
    strokeWidth: 0.932643,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M200.677 86.4121L199.914 94.0512",
    stroke: "#D2294B",
    strokeWidth: 0.932643,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8032 70.8764V53.8891C97.8032 53.6004 98.0366 53.3677 98.3229 53.3677H108.35L112.259 57.2834V70.8764C112.259 71.1651 112.026 71.3978 111.739 71.3978H98.3229C98.0367 71.3978 97.8032 71.1651 97.8032 70.8764Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeWidth: 0.932643
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M109.022 56.1205V54.0272L111.6 56.6049H109.506C109.239 56.6049 109.022 56.3881 109.022 56.1205Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeWidth: 0.932643
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M121.119 60.1513V43.164C121.119 42.8753 121.353 42.6426 121.639 42.6426H131.666L135.575 46.5583V60.1513C135.575 60.44 135.342 60.6727 135.055 60.6727H121.639C121.353 60.6727 121.119 60.44 121.119 60.1513Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeWidth: 0.932643
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M132.338 45.3954V43.3021L134.916 45.8798H132.822C132.555 45.8798 132.338 45.663 132.338 45.3954Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeWidth: 0.932643
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8032 95.7626V78.7753C97.8032 78.4866 98.0366 78.2539 98.3229 78.2539H108.35L112.259 82.1696V95.7626C112.259 96.0513 112.026 96.284 111.739 96.284H98.3229C98.0367 96.284 97.8032 96.0514 97.8032 95.7626Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeWidth: 0.932643
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M109.022 81.0068V78.9134L111.6 81.4911H109.506C109.239 81.4911 109.022 81.2743 109.022 81.0068Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeWidth: 0.932643
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M121.119 85.037V68.0497C121.119 67.761 121.353 67.5283 121.639 67.5283H131.666L135.575 71.444V85.037C135.575 85.3257 135.342 85.5584 135.055 85.5584H121.639C121.353 85.5584 121.119 85.3258 121.119 85.037Z",
    fill: "white",
    stroke: "#D2294B",
    strokeWidth: 0.932643
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M132.338 70.2812V68.1878L134.916 70.7655H132.822C132.555 70.7655 132.338 70.5487 132.338 70.2812Z",
    fill: "white",
    stroke: "#D2294B",
    strokeWidth: 0.932643
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8032 120.477V103.49C97.8032 103.201 98.0366 102.969 98.3229 102.969H108.35L112.259 106.884V120.477C112.259 120.766 112.026 120.999 111.739 120.999H98.3229C98.0367 120.999 97.8032 120.766 97.8032 120.477Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeWidth: 0.932643
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M109.022 105.722V103.628L111.6 106.206H109.506C109.239 106.206 109.022 105.989 109.022 105.722Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeWidth: 0.932643
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M121.119 109.752V92.7651C121.119 92.4764 121.353 92.2437 121.639 92.2437H131.666L135.575 96.1594V109.752C135.575 110.041 135.342 110.274 135.055 110.274H121.639C121.353 110.274 121.119 110.041 121.119 109.752Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeWidth: 0.932643
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M132.338 94.9965V92.9031L134.916 95.4808H132.822C132.555 95.4808 132.338 95.2641 132.338 94.9965Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeWidth: 0.932643
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M167.665 67.5981L170.15 71.2121C171.861 73.6999 172.717 74.9438 172.387 76.1734C172.058 77.4029 170.695 78.0524 167.969 79.3514L164.01 81.2385C162.811 81.8097 162.212 82.0953 161.861 81.8085C161.509 81.5218 161.68 80.8861 162.02 79.6149L162.57 77.5626C158.469 76.4638 153.524 77.1486 150.977 79.8161C153.657 69.8147 160.403 68.9424 164.58 70.0616L165.13 68.0093C165.47 66.7381 165.641 66.1025 166.089 66.0298C166.536 65.9572 166.912 66.5042 167.665 67.5981Z",
    fill: "#D2294B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 112.617V52.4958C29.5 50.828 30.8103 49.5 32.3976 49.5H67.4041L81.5252 64.029V112.617C81.5252 114.285 80.215 115.613 78.6276 115.613H32.3976C30.8109 115.613 29.5 114.286 29.5 112.617Z",
    fill: "white",
    stroke: "#1D1D1D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35.2383,
    y: 93.4814,
    width: 40.5489,
    height: 17.1684,
    rx: 2.09589,
    fill: "#D2294B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0811 105.559V98.5728H49.2537C50.0288 98.5728 50.6265 98.7709 51.0469 99.1673C51.4673 99.5571 51.6775 100.102 51.6775 100.802C51.6775 101.503 51.4673 102.051 51.0469 102.447C50.6265 102.844 50.0288 103.042 49.2537 103.042H47.6082V105.559H46.0811ZM47.6082 101.853H48.9975C49.8054 101.853 50.2094 101.503 50.2094 100.802C50.2094 100.115 49.8054 99.7718 48.9975 99.7718H47.6082V101.853Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6239 105.559V98.5728H55.3433C56.5257 98.5728 57.442 98.8766 58.0923 99.4844C58.7425 100.086 59.0677 100.944 59.0677 102.061C59.0677 103.177 58.7425 104.04 58.0923 104.647C57.442 105.255 56.5257 105.559 55.3433 105.559H52.6239ZM54.1511 104.301H55.2546C56.7326 104.301 57.4715 103.554 57.4715 102.061C57.4715 100.575 56.7326 99.8313 55.2546 99.8313H54.1511V104.301Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2541 105.559V98.5728H64.944V99.7718H61.7813V101.476H64.7273V102.675H61.7813V105.559H60.2541Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.7063 68.5093H38.3645C37.5025 68.5093 36.8037 69.2081 36.8037 70.07V71.6308C36.8037 72.4928 37.5025 73.1916 38.3645 73.1916H72.7063C73.5683 73.1916 74.2671 72.4928 74.2671 71.6308V70.07C74.2671 69.2081 73.5683 68.5093 72.7063 68.5093Z",
    fill: "#D2294B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7063 76.313H38.3645C37.5025 76.313 36.8037 77.0118 36.8037 77.8738V79.4345C36.8037 80.2965 37.5025 80.9953 38.3645 80.9953H72.7063C73.5683 80.9953 74.2671 80.2965 74.2671 79.4345V77.8738C74.2671 77.0118 73.5683 76.313 72.7063 76.313Z",
    fill: "#D2294B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7063 84.1167H38.3645C37.5025 84.1167 36.8037 84.8155 36.8037 85.6775V87.2382C36.8037 88.1002 37.5025 88.799 38.3645 88.799H72.7063C73.5683 88.799 74.2671 88.1002 74.2671 87.2382V85.6775C74.2671 84.8155 73.5683 84.1167 72.7063 84.1167Z",
    fill: "#D2294B"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2905 60.3933V50.236L80.8873 63.2578H71.0452C69.5396 63.2578 68.2905 61.9915 68.2905 60.3933Z",
    fill: "white",
    stroke: "#1D1D1D"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeletePages);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/delete_pages.5c5d095437c73098c5c0f93ab8b33d0f.svg";